const language = {
  'admin.language.hetmet': 'Languages',
  'admin.language.breadcrumb.heading': 'List language',
  'admin.language.breadcrumb.parent': 'Language',
  'admin.language.noti.create-language.success': 'New language added successfully!',
  'admin.language.noti.create-language.failure': 'Adding new language failed! Please try again later.',
  'admin.language.noti.update-language.success': 'Default language changed successfully!',
  'admin.language.noti.update-language.failure': 'Changing the default language failed! Please try again later.',
  'admin.language.noti.delete-language.success': 'Language deletion successful!',
  'admin.language.noti.delete-language.failure': 'Language deletion failed! Please try again later.',
  'admin.language.column.key': 'Key',
  'admin.language.column.name': 'Name',
  'admin.language.column.default': 'Default',
  'admin.language.label.add': 'Add language',
  'admin.language.modal.delete.title': 'Confirm deletion of language!',
  'admin.language.modal.delete.description': 'You definitely want to remove this language?',
  'admin.language.custom.modal.create.label.key': 'Choose language',
  'admin.language.custom.modal.create.error-msg.key.required': 'Please enter the key!',
  'admin.language.custom.modal.create.error-msg.key.regex': 'The key is invalid!',
};

export default {
  ...language,
};
